module.exports = __webpack_public_path__ + "static/img/cooperation02.8d0e925.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperation02.png
// module id = eWjl
// module chunks = 1